import { call, put, takeLatest } from 'redux-saga/effects';
import {
  createVendor,
  createVendorEvaluation,
  deleteVendor,
  deleteVendorEvaluation,
  getVendorDetail,
  getVendorList,
  updateVendor,
} from '../../api/constlink';
import {
  deleteVendorAsync,
  DELETE_VENDOR,
  getVendorDetailAsync,
  getVendorListAsync,
  GET_VENDOR_DETAIL,
  GET_VENDOR_LIST,
  updateVendorAsync,
  UPDATE_VENDOR,
  createVendorAsync,
  CREATE_VENDOR,
  createVendorEvaluationAsync,
  deleteVendorEvaluationAsync,
  CREATE_VENDOR_EVALUATION,
  DELETE_VENDOR_EVALUATION,
} from './actions';
import { Vendor, VendorEvaluation } from './types';

function* getVendorListSaga(
  action: ReturnType<typeof getVendorListAsync.request>,
) {
  try {
    const vendors: Vendor[] = yield call(getVendorList, action.payload);
    yield put(getVendorListAsync.success(vendors));
  } catch (e: any) {
    yield put(getVendorListAsync.failure(e));
  }
}

function* updateVendorSaga(
  action: ReturnType<typeof updateVendorAsync.request>,
) {
  try {
    const vendor: Vendor = yield call(updateVendor, action.payload);
    yield put(updateVendorAsync.success(vendor));
  } catch (e: any) {
    yield put(updateVendorAsync.failure(e));
  }
}

function* deleteVendorSaga(
  action: ReturnType<typeof deleteVendorAsync.request>,
) {
  try {
    const vendorId: number = yield call(deleteVendor, action.payload);
    yield put(deleteVendorAsync.success(vendorId));
  } catch (e: any) {
    yield put(deleteVendorAsync.failure(e));
  }
}

function* getVendorDetailSaga(
  action: ReturnType<typeof getVendorDetailAsync.request>,
) {
  try {
    const vendor: Vendor = yield call(getVendorDetail, action.payload);
    yield put(getVendorDetailAsync.success(vendor));
  } catch (e: any) {
    yield put(getVendorDetailAsync.failure(e));
  }
}

function* createVendorSaga(
  action: ReturnType<typeof createVendorAsync.request>,
) {
  try {
    const vendor: Vendor = yield call(createVendor, action.payload);
    yield put(createVendorAsync.success(vendor));
  } catch (e: any) {
    yield put(createVendorAsync.failure(e));
  }
}

function* createVendorEvaluationSaga(
  action: ReturnType<typeof createVendorEvaluationAsync.request>,
) {
  try {
    const vendorEvaluation: VendorEvaluation = yield call(
      createVendorEvaluation,
      action.payload,
    );
    yield put(createVendorEvaluationAsync.success(vendorEvaluation));
  } catch (e: any) {
    yield put(createVendorEvaluationAsync.failure(e));
  }
}

function* deleteVendorEvaluationSaga(
  action: ReturnType<typeof deleteVendorEvaluationAsync.request>,
) {
  try {
    const vendorEvaluationId: number = yield call(
      deleteVendorEvaluation,
      action.payload,
    );
    yield put(deleteVendorEvaluationAsync.success(vendorEvaluationId));
  } catch (e: any) {
    yield put(deleteVendorEvaluationAsync.failure(e));
  }
}

export function* vendorsSaga() {
  yield takeLatest(GET_VENDOR_LIST, getVendorListSaga);
  yield takeLatest(UPDATE_VENDOR, updateVendorSaga);
  yield takeLatest(DELETE_VENDOR, deleteVendorSaga);
  yield takeLatest(GET_VENDOR_DETAIL, getVendorDetailSaga);
  yield takeLatest(CREATE_VENDOR, createVendorSaga);

  yield takeLatest(CREATE_VENDOR_EVALUATION, createVendorEvaluationSaga);
  yield takeLatest(DELETE_VENDOR_EVALUATION, deleteVendorEvaluationSaga);
}
